import React, { useState, useEffect, useCallback, useRef } from "react";
import {
    Breadcrumb, Layout, theme, Input, List, Descriptions, Button, AutoComplete, Popover,
    Space, Col, Row, Spin, Modal, Tooltip,
    Checkbox, message
} from "antd";
import {
    InfoCircleOutlined
} from '@ant-design/icons';
import Copilot from "../pages/Copilot";
import { useMsal } from '@azure/msal-react';
import '../CSS/style-guide.css'
import BackendService from "../components/BackendService";
import Nav from "../components/Nav";
import HeaderJs from "../components/HeaderJs";
import ModalJs from "../components/ModalJs";
import FooterJs from "../components/FooterJs";
import MultiSelect from "../components/MultiSelect";
import DOMPurify from 'dompurify';
import ExportToExcel from "../components/ExportToExcel";
import StaticTreeMultiSelect from "../components/StaticTreeMultiSelect";

const { Header, Content } = Layout;

const ContractSearch = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [docCount, setDocCount] = useState('');
    const [searchText, setSearchText] = useState('');
    const [prevText, setPrevText] = useState('');
    const [selectedContracts, setSelectedContracts] = useState([]);
    const [selectedClause, setSelectedClause] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState([]);
    const [selectedCommodities, setSelectedCommodities] = useState([]);
    const [selectedParentContract, setSelectedParentContract] = useState([]);
    const [selectedcontractType, setSelectedcontractType] = useState([]);
    const [selectedsigningLegalEntity, setSelectedsigningLegalEntity] = useState([]);
    const [selectedpaymentTerms, setSelectedpaymentTerms] = useState([]);
    const [selectedStdClause, setSelectedStdClause] = useState([]);
    const [query, setQuery] = useState("");
    const [dropDownData, setDropdownData] = useState([]);
    const [RegionArrayData, setRegionArrayData] = useState({});
    const [ContractId, setContractId] = useState('');
    const [Title, setTitle] = useState('');
    const [Description, setDescription] = useState('');
    const [ContractType, setContractType] = useState('');
    const [ContractStatus, setContractStatus] = useState('');
    const [AtosContractTemplate, setAtosContractTemplate] = useState('');
    const [HierarchicalType, setHierarchicalType] = useState('');
    const [ParentAgreement, setParentAgreement] = useState('');
    const [Commodities, setCommodities] = useState('');
    const [RelatedToALease, setRelatedToALease] = useState('');
    const [Regions, setRegions] = useState('');
    const [EffectiveDate, setEffectiveDate] = useState('');
    const [ExpirationDate, setExpirationDate] = useState('');
    const [ExpirationTermType, setExpirationTermType] = useState('');
    const [AutoRenewalInterval, setAutoRenewalInterval] = useState('');
    const [MaximumNumberOfRenewals, setMaximumNumberOfRenewals] = useState('');
    const [Supplier, setSupplier] = useState('');
    const [SigningLegalEntity, setSigningLegalEntity] = useState('');
    const [Customer, setCustomer] = useState('');
    const [ContractAmount, setContractAmount] = useState('');
    const [MinimumFinancialCommitment, setMinimumFinancialCommitment] = useState('');
    const [PaymentTerms, setPaymentTerms] = useState('');
    const [BillingSchedule, setBillingSchedule] = useState('');
    const [MaximumPenalty, setMaximumPenalty] = useState('');
    const [autocompleteResults, setAutocompleteResults] = useState([]);
    const [autoComp, setAutoComp] = useState([]);
    const [distinctData, setDistinctData] = useState([]);
    const [clauses, setClauses] = useState([]);
    const [searchResults, setSearchResults] = useState({ docCount: 0, clauseHeaders: new Set(), chunks: new Set(), });
    const [skip, setSkip] = useState(0);
    const [initLoading, setInitLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalType, setModalType] = useState([]);
    const [isContract, setIsContract] = useState(false);
    const [isParentContract, setIsParentContract] = useState(false);
    const [resultLengths, setResultLengths] = useState([]);
    const [distDatalenght, setDistDataLenght] = useState([]);
    const [hasChanged, setHasChanged] = useState(false);
    const [selectedContract, setSelectedContract] = useState('');
    const { instance, accounts } = useMsal();
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [chatContract, setChatContract] = useState(null);
    const [regionTreeData, setRegionTreeData] = useState([]);
    const [commoditiesTreeData, setCommoditiesTreeData] = useState([]);

    // new: control visibility and copy action for selected contract IDs shown in Copilot modal
    const [showContractIds, setShowContractIds] = useState(false);
    const handleToggleShowIds = () => setShowContractIds(prev => !prev);
    const handleCopyIds = async () => {
        const ids = Array.isArray(chatContract?.selectedContracts)
            ? chatContract.selectedContracts.map(c => c.contractId).join(', ')
            : '';
        if (!ids) {
            message.info('No contract ids to copy');
            return;
        }
        try {
            await navigator.clipboard.writeText(ids);
            message.success('Contract IDs copied to clipboard');
        } catch (err) {
            console.error('Copy failed', err);
            message.error('Failed to copy contract ids');
        }
    };

    // unlimited selection (use sessionStorage to persist while session lasts)
    const [selectedKeys, setSelectedKeys] = useState(() => {
        try {
            const saved = sessionStorage.getItem('contractSearchSelectedKeys');
            return saved ? JSON.parse(saved) : [];
        } catch (e) {
            return [];
        }
    });
    const [selectAll, setSelectAll] = useState(false);
    // compute indeterminate state for the Select All checkbox
    const totalDistinct = distinctData.length;
    const selectedCount = selectedKeys.length;
    const isIndeterminate = selectedCount > 0 && selectedCount < totalDistinct;

    const [messages, setMessages] = useState(() => {
        const saved = localStorage.getItem('chatMessages');
        const initialMessages = saved ? JSON.parse(saved) : [];
        if (initialMessages.length === 0) {
            initialMessages.push({
                role: 'assistant',
                text: "Hi, I'm SCIA Agent. You can ask me questions about active Vendor contracts registered in Ariba.",
                timestamp: new Date().toISOString(),
                sender: 'Assistant'
            });
        }
        return initialMessages;
    });

    // AI-backed summary returned by server (/api/contract-search) — cached in Redis
    const [aiSummary, setAiSummary] = useState(null);

    const timeoutRef = useRef(null);
    const searchTextRef = useRef(searchText);
    const chatEndRef = useRef(null);

    const content = (
        <div style={{ width: '700px', whiteSpace: 'normal' }}>
            <p>1. Enter terms in the Search box and select Filter Conditions.
                When Contract or Parent Contract is selected, the search becomes targeted, and other filters are disabled.
            </p>
            <p>
                2. Use double quotes ("Payment Terms") to search for exact phrases. Without quotes (Payment Terms),
                find records that contain either of the word.
            </p>
        </div>
    );

    const StdClausesInfo = (
        <div>Standard Clauses are assigned by an AI Text Classification model.
            The number in bracket indicate the confidence score of the model.</div>
    )

    //use Effect
    useEffect(() => {
        FetchDropdownData();
        FetchRegionsDropdownData();
        FetchCommoditiesDropdownData();
    }, []);

    // Run buildQuery only when its dependencies change (avoid infinite render loop)
    useEffect(() => {
        buildQuery();
    });

    useEffect(() => {
        makeDataDistinct();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    useEffect(() => {
        const autoCompValues = autocompleteResults.map(au => au.text);
        setAutoComp(autoCompValues);
    }, [autocompleteResults]);

    useEffect(() => {
        searchInData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [distinctData]);

    useEffect(() => {
        searchTextRef.current = searchText;
    }, [searchText]);

    // Add this effect to listen for Enter key
    useEffect(() => {

        const handleKeyDown = (event) => {
            const webchat = document.getElementById('webchat-embedded');
            const pressedInWebchat = webchat?.contains(event.target);

            if (isChatOpen && pressedInWebchat && event.key === 'Enter') return;

            if (event.key === 'Enter' && hasChanged && !pressedInWebchat) {
                if (timeoutRef.current) clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(async () => {
                    await onSearch();
                    setHasChanged(false);
                }, 3000);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasChanged]);

    useEffect(() => {
        setHasChanged(true)
    }, [selectedContracts, selectedParentContract, selectedRegion, selectedSupplier, selectedCommodities, selectedsigningLegalEntity, selectedcontractType, selectedStdClause]);

    useEffect(() => {
        if (accounts.length > 0) {
            instance.setActiveAccount(accounts[0]);
        }
    }, [accounts, instance]);

    useEffect(() => {
        localStorage.setItem('chatMessages', JSON.stringify(messages));
        chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);

    // Keep selectAll in sync when user selects/deselects individual items
    useEffect(() => {
        const total = distinctData.length;
        const selectedCount = selectedKeys.length;

        if (total === 0) {
            setSelectAll(false);
        } else if (selectedCount === total) {
            setSelectAll(true);
        } else {
            setSelectAll(false);
        }
    }, [selectedKeys, distinctData]);

    const handleInputChange = (data) => {
        setSearchText(data);
        setHasChanged(true);
        const query = data;
        if (query) {
            fetchAutocompleteResults(query);
        }
        setSkip(0);
        setData([]);
        setResultLengths([]);
        setDistDataLenght([]);
    };

    // const getRedirectUri = () => {
    //     if (typeof window !== 'undefined') {
    //         return window.location.origin;
    //     }
    //     return '';
    // };

    // const openChatForItem = (item) => {
    //     // Build a clean context object the bot can consume
    //     const ctx = {
    //         contractId: item.contractId,
    //         contractTitle: item.ContractName,
    //         documentName: item.DocumentName,
    //         supplier: item?.supplier?.name,
    //     };
    //     setChatContract(ctx);
    //     setIsChatOpen(true);
    // };

    const keyOf = (item) => `${item.contractId}-${item.DocumentName ?? ''}`;
    const isChecked = (item) => selectedKeys.includes(keyOf(item));
    const handleCheckBoxChange = (item, index, checked) => {
        const key = keyOf(item);
        setSelectedKeys(prev => {
            if (checked) {
                if (prev.includes(key)) return prev;
                return [...prev, key];
            } else {
                return prev.filter(k => k !== key);
            }
        });
    };

    // Toggle Select All: if checked -> select all visible results; if unchecked -> clear all
    const handleSelectAllToggle = (checked) => {
        if (checked) {
            const allKeys = distinctData.map(item => keyOf(item));
            setSelectedKeys(allKeys);
            setSelectAll(true);
        } else {
            setSelectedKeys([]);
            setSelectAll(false);
        }
    };

    // Return selected items in the same order as they appear in the results (distinctData)
    const getSelectedItemsInResultsOrder = useCallback(() => {
        const setKeys = new Set(selectedKeys);
        return distinctData.filter(item => setKeys.has(keyOf(item)));
    }, [selectedKeys, distinctData]);

    // Called when user clicks Analyze -> open small input modal first
    const handleAnalyzeClick = () => {
        if (selectedKeys.length === 0) {
            message.warning("Please select at least one contract.");
            return;
        }
        const selectedInOrder = getSelectedItemsInResultsOrder();
        const totalSelected = selectedInOrder.length;
        const toSubmit = selectedInOrder.slice(0, 10);

        const ctx = {
            sourcePage: 'ContractSearch',
            query: searchTextRef.current || searchText || '',
            selectedContracts: toSubmit.map(i => ({ contractId: i.contractId, contractTitle: i.ContractName })),
            selectedCount: totalSelected
        };
        // open existing Copilot modal with context
        setChatContract(ctx);
        setIsChatOpen(true);
        // pre-warm server copilot (cached in Redis) and then open modal
        (async () => {
            try {
                const token = await acquireBackendToken();
                await BackendService.copilot(`Prewarm: Analyze ${ctx.selectedContracts.map(c => c.contractId).join(', ')}`, ctx, token);
            } catch (e) {
                // ignore pre-warm errors, still open modal
            } finally {
                setChatContract(ctx);
                setIsChatOpen(true);
            }
        })();
    };

    //Apis
    const FetchDropdownData = () => {
        BackendService.FetchDropdownData()
            .then((response) => {
                const facets = response.data["@search.facets"];
                setDropdownData(facets);
                setRegionArrayData(facets['regions'] || []);
                console.log('Array region data', facets);
            })
            .catch((error) => {
                console.error("Error:", error);
                setDropdownData([]);
            });
    };

    const FetchRegionsDropdownData = () => {
        BackendService.FetchRegionsDropdownData()
            .then((response) => {
                const facets = response.data["@search.facets"];
                setRegionTreeData(facets);
                console.log('Array region data', facets);
            })
            .catch((error) => {
                console.error("Error:", error);
                setDropdownData([]);
            });
    };

    // Helper: extract the commodities array from various facet shapes
    const getCommoditiesArrayFromFacets = (facets) => {
        if (!facets) return [];
        if (Array.isArray(facets)) return facets;
        if (Array.isArray(facets.commodities)) return facets.commodities;
        if (Array.isArray(facets['commodities/name'])) return facets['commodities/name'];
        if (Array.isArray(facets.categories)) return facets.categories;
        if (Array.isArray(facets['categories/name'])) return facets['categories/name'];
        if (Array.isArray(facets.HierarchyPath_Description)) return facets.HierarchyPath_Description;
        for (const k of Object.keys(facets || {})) {
            if (!Array.isArray(facets[k]) || !facets[k].length) continue;
            const lk = String(k).toLowerCase();
            if (lk.includes('commodit') || lk.includes('category')) return facets[k];
        }
        return [];
    };

    // // Keep only commodity nodes that contain a 'B' code (e.g. "B172400").
    // const filterCommoditiesTreeByBCode = (facets) => {
    //     const raw = getCommoditiesArrayFromFacets(facets);
    //     if (!Array.isArray(raw)) return [];

    //     const normalize = s => String(s || '').replace(/\u00A0/g, ' ').trim();
    //     const hasB = (node) => {
    //         if (!node) return false;
    //         const candidate = normalize(node.value || node.name || node.code || node.label || node);
    //         if (!candidate) return false;
    //         // token like "B172400" or "B 172400" etc.
    //         return /\bB[0-9A-Za-z_-]+\b/.test(candidate) || /(^|\s)B\s*\d{3,}($|\s|,|\.)/i.test(candidate);
    //     };

    //     // If nodes are flat (objects with value fields) just filter them
    //     const flatLike = raw.every(item => typeof item === 'object' && ('value' in item || 'name' in item || 'label' in item));
    //     if (flatLike) {
    //         const filtered = raw.filter(item => hasB(item));
    //         if (filtered.length === 0) console.warn('filterCommoditiesTreeByBCode: no items matched B-code', raw.slice(0, 6));
    //         return filtered;
    //     }

    //     // Otherwise, do recursive filtering (preserve parents when children match)
    //     const filterRec = (node) => {
    //         if (!node) return null;
    //         const children = Array.isArray(node.children)
    //             ? node.children.map(filterRec).filter(Boolean)
    //             : [];
    //         if (hasB(node) || children.length > 0) {
    //             return { ...node, children: children.length > 0 ? children : (node.children || []) };
    //         }
    //         return null;
    //     };
    //     return raw.map(filterRec).filter(Boolean);
    // };

    const FetchCommoditiesDropdownData = () => {
        BackendService.FetchCommoditiesDropdownData()
            .then((response) => {
                const facets = response.data?.["@search.facets"];
                const raw = getCommoditiesArrayFromFacets(facets);
                setCommoditiesTreeData(raw);
                console.log('FetchCommoditiesDropdownData: commodities count=', raw.length);
            })
            .catch((error) => {
                console.error("FetchCommoditiesDropdownData Error:", error);
                setCommoditiesTreeData([]);
            });
    };

    const fetchAutocompleteResults = async (query) => {
        try {
            BackendService.AzureAiV2Autocomplete(query, "sgText")
                .then((response) => {
                    setAutocompleteResults(response.data.value);
                })
                .catch((error) => {
                    console.error("Error:", error);
                    setAutocompleteResults([]);
                });
        } catch (error) {
            console.error('Error fetching autocomplete results:', error);
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onSearch = useCallback((text) => {
        let skip1 = 0;
        setLoading(true);
        const nextSkip = 1000;
        if (text === 'loadMore' && data.length < docCount && prevText === searchTextRef.current) {
            skip1 = skip + nextSkip
        }
        const searchParams = {
            searchText: searchTextRef.current,
        };

        BackendService.AzureAiV2(searchParams, query, skip1)
            .then((response) => {
                const newData = response.data.value;
                console.log('fetched Data successfully');
                if (searchText === prevText && text === 'loadMore') {
                    setData(prevData => [...prevData, ...newData]);
                    setSkip(skip + nextSkip);
                } else {
                    setData(newData);
                }
                setInitLoading(false);
                setDocCount(response.data["@odata.count"]);
                // call server-side contract-search (cached via Redis). Not replacing AzureAiV2 here:
                (async () => {
                    try {
                        const token = await acquireBackendToken();
                        const aiResp = await BackendService.contractSearch(searchTextRef.current || searchText, null, token);
                        // axios response -> aiResp.data
                        setAiSummary(aiResp.data?.results ?? aiResp.data);
                    } catch (e) {
                        console.warn('Server contract-search failed (cache not available)', e);
                        setAiSummary(null);
                    }
                })();
                setLoading(false);
                window.dispatchEvent(new Event('resize'));
            })
            .catch((error) => {
                console.error("Error:", error);
                setLoading(false);
            });

        setPrevText(searchTextRef.current);
    })

    const makeDataDistinct = () => {
        // Group items by contractId + ContractName + DocumentName so we can collect all document ids
        const groups = new Map();

        data.forEach(item => {
            const { contractId, ContractName, DocumentName } = item;
            const key = `${contractId}-${ContractName}-${DocumentName}`;
            if (!groups.has(key)) groups.set(key, []);
            groups.get(key).push(item);
        });

        // Build distinct array where each entry preserves the first item but also stores all related document ids
        const distData = Array.from(groups.values()).map(group => {
            const first = group[0];
            const allDocumentIds = Array.from(new Set(group.map(g => g.id).filter(Boolean)));
            return { ...first, allDocumentIds };
        });

        // Sort distData based on the numbers after the hyphen in id (use the first id available)
        distData.sort((a, b) => {
            const parseId = (id) => {
                const idToParse = id || '';
                const versionMatch = idToParse.match(/-v(\d+)-/);
                const baseId = idToParse.split('-')[0] || '';
                const version = versionMatch ? parseInt(versionMatch[1], 10) : 0; // 0 for basic version
                const suffix = parseInt(idToParse.split('-').pop(), 10) || 0; // the last number after the last dash
                return { baseId, version, suffix };
            };

            const aParsed = parseId(a.id);
            const bParsed = parseId(b.id);

            if (aParsed.baseId === bParsed.baseId) {
                if (aParsed.version !== bParsed.version) {
                    return bParsed.version - aParsed.version; // higher version first
                } else {
                    return aParsed.suffix - bParsed.suffix; // sort by suffix if versions are equal
                }
            } else {
                return aParsed.baseId.localeCompare(bParsed.baseId); // sort by base ID if different
            }
        });

        setResultLengths(data.length);
        setDistDataLenght(prev => [...prev, distData.length]);
        setDistinctData(distData);
    };

    const searchInData = () => {
        let docCount = 0;
        const lowerCaseSearchText = searchText.toLowerCase();
        const seen = new Set();
        const distData = [];

        // Clause header tracking
        const clauseHeaderSetsByContractIdAndDoc = {};

        // Filter distinctData for search text match
        distinctData.forEach(doc => {
            if (doc.chunk && doc.chunk.toLowerCase().includes(lowerCaseSearchText)) {
                docCount++;
            }
        });

        // Filter and group clause headers
        data.forEach(item => {
            const { clause_header, chunk, contractId, DocumentName } = item;
            const key = `${contractId}|${DocumentName}|${clause_header}|${chunk}`;

            if (!seen.has(key)) {
                distData.push(item);
                seen.add(key);

                // Initialize nested structure
                if (!clauseHeaderSetsByContractIdAndDoc[contractId]) {
                    clauseHeaderSetsByContractIdAndDoc[contractId] = {};
                }

                if (!clauseHeaderSetsByContractIdAndDoc[contractId][DocumentName]) {
                    clauseHeaderSetsByContractIdAndDoc[contractId][DocumentName] = new Set();
                }

                clauseHeaderSetsByContractIdAndDoc[contractId][DocumentName].add(clause_header);
            }
        });

        // Convert sets to counts
        const uniqueClauseHeaderCountsByContractIdAndDoc = {};
        for (const contractId in clauseHeaderSetsByContractIdAndDoc) {
            for (const documentName in clauseHeaderSetsByContractIdAndDoc[contractId]) {
                const key = `${contractId}|${documentName}`;
                uniqueClauseHeaderCountsByContractIdAndDoc[key] = clauseHeaderSetsByContractIdAndDoc[contractId][documentName].size;
            }
        }

        setSearchResults({
            docCount,
            contractIdCounts: {}, // Optional: can be updated similarly
            distData,
            uniqueClauseHeaderCountsByContractIdAndDoc,
        });
    };

    const normalizeOptions = (dataArray) =>
        Array.isArray(dataArray)
            ? [...new Set(dataArray.map(doc => doc?.value).filter(Boolean))]
                .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
                .map(val => ({ value: val, label: val }))
            : [];

    const distinctprojectId = normalizeOptions(dropDownData.projectId);

    const distinctParentC = normalizeOptions(dropDownData.parentAgreement);

    const distinctSupplier = normalizeOptions(dropDownData["supplier/name"]);

    const distinctRegion = normalizeOptions(dropDownData["regions/name"]);

    const distinctContractType = normalizeOptions(dropDownData.contractType);

    const distinctSigningLegalEntity = normalizeOptions(dropDownData.signingLegalEntity);

    const distinctStdClauses = normalizeOptions(dropDownData["stdClauses/clauseLabel"]);

    const distinctCommodities = Array.isArray(dropDownData["commodities/name"])
        ? dropDownData["commodities/name"]
            .map(doc => {
                const parts = doc?.value?.split(' ') || [];
                const id = parts[parts.length - 1];
                const name = parts.slice(0, -1).join(' ');
                const formatted = `${id} ${name}`;
                return doc?.value ? { value: doc.value, label: formatted } : null;
            })
            .filter(Boolean)
            .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()))
        : [];

    const onLoadMore = () => {
        setInitLoading(true);
        setLoading(true);
        onSearch('loadMore');
    };

    const loadMore =
        data.length !== docCount && data.length > 0 && !initLoading && !loading ? (
            <div
                style={{
                    textAlign: 'center',
                    marginTop: 12,
                    height: 32,
                    lineHeight: '32px',
                }}
            >
                <Button type="primary" onClick={onLoadMore}>load more</Button>
            </div>
        ) : null;

    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    const buildQuery = useCallback(() => {
        let conditions = [];

        if (selectedContracts.length > 0 && !isParentContract) {
            const contractQuery = selectedContracts.map(cont => `projectId eq '${cont}'`).join(" or ");
            conditions.push(`(${contractQuery})`);
        }

        if (selectedParentContract.length > 0 && !isContract) {
            const ParentcontractQuery = selectedParentContract.map(pc => `parentAgreement eq '${pc}'`).join(" or ");
            conditions.push(`(${ParentcontractQuery})`);
        }

        if (selectedClause.length > 0 && !isContract && !isParentContract) {
            const clauseQuery = selectedClause.map(cla => `clause_header eq '${cla}'`).join(" or ");
            conditions.push(`(${clauseQuery})`);
        }

        if (selectedSupplier.length > 0 && !isContract && !isParentContract) {
            const supplierQuery = selectedSupplier.map(sup => `supplier/name eq '${sup}'`).join(" or ");
            conditions.push(`(${supplierQuery})`);
        }

        if (selectedRegion.length > 0 && !isContract && !isParentContract) {
            // Split selected region strings on '|' and generate a clause for each token.
            // Example selectedRegion item: "Americas|North America"
            const esc = s => (s || '').replace(/'/g, "''");
            const regionQuery = selectedRegion
                .map(sel => {
                    const tokens = (sel || '').split('|').map(p => p.trim()).filter(Boolean);
                    if (tokens.length === 0) return null;
                    // For each token create a clause matching region name or any level fields
                    const tokenClauses = tokens.map(token => {
                        if (token === '__ALL__') return null; // skip explicit all marker
                        const t = esc(token);
                        return `regions/any(r: r/name eq '${t}' )`;
                    }).filter(Boolean);
                    return tokenClauses.join(' or ');
                })
                .filter(Boolean)
                .join(' or ');
            if (regionQuery) conditions.push(`(${regionQuery})`);
        }

        if (selectedCommodities.length > 0 && !isContract && !isParentContract) {
            const commoditiesQuery = selectedCommodities.map(comm => `commodities/any(r: r/name eq '${comm}')`).join(" or ");
            conditions.push(`(${commoditiesQuery})`);
        }

        if (selectedcontractType.length > 0 && !isContract && !isParentContract) {
            const contractTypeQuery = selectedcontractType.map(ct => `contractType eq '${ct}'`).join(" or ");
            conditions.push(`(${contractTypeQuery})`);
        }

        if (selectedsigningLegalEntity.length > 0 && !isContract && !isParentContract) {
            const signingLegalEntityQuery = selectedsigningLegalEntity.map(sle => `signingLegalEntity eq '${sle}'`).join(" or ");
            conditions.push(`(${signingLegalEntityQuery})`);
        }

        if (selectedpaymentTerms.length > 0 && !isContract && !isParentContract) {
            const paymentTermsQuery = selectedpaymentTerms.map(pt => `paymentTerms eq '${pt}'`).join(" or ");
            conditions.push(`(${paymentTermsQuery})`);
        }

        if (selectedStdClause.length > 0 && !isContract && !isParentContract) {
            const selectedStdClauseQuery = selectedStdClause.map(sc => `stdClauses/any(r: r/clauseLabel eq '${sc}')`).join(" or ");
            conditions.push(`(${selectedStdClauseQuery})`);
        }

        setQuery(conditions.length > 0 ? conditions.join(" and ") : "");
    }, [selectedContracts, isParentContract, selectedParentContract, isContract, selectedClause, selectedSupplier, selectedRegion, selectedCommodities, selectedcontractType, selectedsigningLegalEntity, selectedpaymentTerms, selectedStdClause]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'short' });
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    };

    const handleContractInfo = (contract, index) => {
        const commodityNames = distinctData[index].commodities.map(co => co.name);
        const regionNames = distinctData[index].regions.map(re => re.name);

        const effectData = distinctData[index].effectiveDate;
        const expireDate = distinctData[index].expirationDate;

        setContractId(distinctData[index].contractId);
        setTitle(distinctData[index].title);
        setDescription(distinctData[index].description);
        setContractType(distinctData[index].contractType);
        setContractStatus(distinctData[index].contractStatus);
        setAtosContractTemplate('--');
        setHierarchicalType(distinctData[index].hierarchicalType);
        setParentAgreement(distinctData[index].parentAgreement);
        setCommodities(commodityNames);
        setRelatedToALease('--');
        setRegions(regionNames);
        setEffectiveDate(formatDate(effectData));
        setExpirationDate(formatDate(expireDate));
        setExpirationTermType(distinctData[index].expirationTermType);
        setAutoRenewalInterval(distinctData[index].autoRenewalInterval);
        setMaximumNumberOfRenewals(distinctData[index].maximumNumberOfRenewals);
        setSupplier(distinctData[index].supplier.name);
        setSigningLegalEntity(distinctData[index].signingLegalEntity);
        setCustomer(distinctData[index].Customer);
        setContractAmount('--');
        setMinimumFinancialCommitment('--');
        setPaymentTerms(distinctData[index].paymentTerms);
        setBillingSchedule(distinctData[index].billingSchedule);
        setMaximumPenalty('--');
    }

    const handleContractInfoClick = (item, index) => {
        handleContractInfo(item, index);
        setModalType('Contract Info');
        setIsModalVisible(true);
        setSelectedContract(item.contractId);
    };

    const handleRelevantClausesClick = (item, index) => {
        extractClauses(item.contractId, index);
        setModalType('Relevent Clauses');
        setIsModalVisible(true);
        setSelectedContract(item.contractId);
    };

    const ContractInfo = [
        {
            key: '1',
            label: <span className="label">contractId</span>,
            children: <span className="child">{ContractId}</span>,
            span: 1
        },
        {
            key: '2',
            label: <span className="">Title</span>,
            children: <span className="">{Title}</span>,
            span: 2
        },
        {
            key: '3',
            label: <span className="">Description</span>,
            span: 3,
            children: (
                <span className="">
                    {Description}
                </span>
            ),
        },
        {
            key: '4',
            label: <span className="">Contract Type</span>,
            children: <span className="">{ContractType}</span>,
            span: 2,
        },
        {
            key: '5',
            label: <span className="">Contract Status</span>,
            children: <span className="">{ContractStatus}</span>,
        },
        {
            key: '6',
            label: 'hierarchicalType',
            children: HierarchicalType,
            span: 3
        },
        {
            key: '7',
            label: 'parentAgreement',
            children: ParentAgreement,
            span: 2
        },
        // {
        //   key: '8',
        //   label: <span className="">Atos contract template</span>,
        //   children: <span className="">{AtosContractTemplate}</span>,
        //   span: 3
        // },
    ];

    const Scope = [
        {
            key: '2',
            label: 'Commodities',
            children: Commodities,
            span: 4,
        },
        // {
        //   key: '2',
        //   label: 'related to a lease',
        //   children: RelatedToALease,
        //   span: 2
        // },
        {
            key: '3',
            label: 'Regions',
            children: Regions,
            span: 3
        },
    ];

    const Lifecycle = [
        {
            key: '1',
            label: 'effectiveDate',
            children: EffectiveDate,
            span: 2
        },
        {
            key: '2',
            label: 'Expiration Date',
            children: ExpirationDate,
            span: 2
        },
        {
            key: '3',
            label: 'expirationTermType',
            children: ExpirationTermType,
            span: 3
        },
        {
            key: '4',
            label: 'autoRenewalInterval',
            children: AutoRenewalInterval,
            span: 2
        },
        {
            key: '5',
            label: 'maximumNumberOfRenewals',
            children: MaximumNumberOfRenewals,
            span: 2
        }
    ];

    const Stakeholders = [
        {
            key: '1',
            label: 'Supplier',
            children: Supplier,
            span: 2
        },
        {
            key: '2',
            label: 'Signing Legal Entity',
            children: SigningLegalEntity,
            span: 2
        },
        {
            key: '3',
            label: 'Customer',
            children: Customer,
            span: 3
        },
    ];

    const Commercials = [
        {
            key: '1',
            label: 'Contract Amount',
            children: ContractAmount,
            span: 3
        },
        // {
        //   key: '2',
        //   label: 'minimum financial commitment',
        //   children: MinimumFinancialCommitment,
        //   span: 2
        // },
        {
            key: '3',
            label: 'Payment Terms',
            children: PaymentTerms,
            span: 2
        },
        {
            key: '4',
            label: 'Billing Schedule',
            children: BillingSchedule,
            span: 2
        },
        // {
        //   key: '5',
        //   label: 'maximum penalty',
        //   children: MaximumPenalty,
        //   span: 3
        // },
    ];

    const highlightKeyword = (textContent, keyword) => {
        if (!keyword) return textContent;

        const pastelColors = [
            '#FFECB3', '#C8E6C9', '#BBDEFB', '#F8BBD0', '#E1BEE7',
            '#D1C4E9', '#B2EBF2', '#FFF9C4', '#DCEDC8', '#FFE0B2'
        ];

        // Extract quoted phrases and individual words
        const phraseRegex = /"([^"]+)"/g;
        const phrases = [];
        let match;
        while ((match = phraseRegex.exec(keyword)) !== null) {
            phrases.push(match[1]);
        }

        const remaining = keyword.replace(phraseRegex, '').trim();
        const words = remaining.split(/\s+/).filter(k => k.trim() !== '');

        const allKeywords = [...phrases, ...words];
        const keywordSet = new Set(allKeywords.map(k => k.toLowerCase()));

        const colorMap = {};
        Array.from(keywordSet).forEach((word, idx) => {
            colorMap[word] = pastelColors[idx % pastelColors.length];
        });

        const processPart = (part, index) => {
            if (typeof part !== 'string') return part;

            // Sort keywords by length to match longer phrases first
            const sortedKeywords = Array.from(keywordSet).sort((a, b) => b.length - a.length);
            const regex = new RegExp(`(${sortedKeywords.map(k => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'gi');
            const splitParts = part.split(regex);

            return splitParts.map((subPart, subIndex) => {
                const lowerSub = subPart.toLowerCase();
                if (keywordSet.has(lowerSub)) {
                    return (
                        <mark key={`${index}-${subIndex}`} style={{ backgroundColor: colorMap[lowerSub] }}>
                            {subPart}
                        </mark>
                    );
                }
                return subPart;
            });
        };

        return (
            <>
                {Array.isArray(textContent)
                    ? textContent.map((part, index) => processPart(part, index))
                    : processPart(textContent, 0)}
            </>
        );
    };

    const removeOverlap = (prevText, currentText) => {
        const maxOverlap = Math.min(prevText.length, currentText.length);
        for (let i = maxOverlap; i > 0; i--) {
            if (prevText.endsWith(currentText.slice(0, i))) {
                return currentText.slice(i);
            }
        }
        return currentText;
    };

    const decodeHtml = (html) => {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    };

    const renderHtmlTable = (htmlString) => {
        // Remove <span> tags but keep their content
        let cleanedHtml = htmlString.replace(/<span[^>]*>(.*?)<\/span>/gi, '$1');
        // Remove colspan attribute from <td> tags
        cleanedHtml = cleanedHtml.replace(/<td[^>]*\scolspan="[^"]*"([^>]*)>/gi, '<td$1>');
        // Remove empty <td> tags (with only whitespace or nothing)
        cleanedHtml = cleanedHtml.replace(/<td[^>]*>\s*<\/td>/gi, '');
        const safeHtml = DOMPurify.sanitize(cleanedHtml);
        return (
            <div
                dangerouslySetInnerHTML={{ __html: safeHtml }}
                style={{ overflowX: 'auto' }}
                className="rendered-table-container"
            />
        );
    };

    const extractClauses = (contractId, index) => {
        const clausePairs = [];
        const keyword = prevText ? prevText.toLowerCase() : searchText.toLowerCase();

        const groupedChunks = {};

        const targetDocumentName = distinctData[index].DocumentName;

        data.forEach(item => {
            if (item.contractId === contractId && item.DocumentName === targetDocumentName) {
                const header = item.clause_header;

                if (!groupedChunks[header]) {
                    groupedChunks[header] = [];
                }
                groupedChunks[header].push(item);
            }
        });

        Object.entries(groupedChunks).forEach(([header, chunks], i) => {
            const sortedChunks = chunks.sort((a, b) => {
                const getChunkNum = id => {
                    const match = id?.match(/_pages_(\d+)$/);
                    return match ? parseInt(match[1], 10) : 0;
                };
                return getChunkNum(a.chunk_id) - getChunkNum(b.chunk_id);
            });

            let combinedChunk = [];
            let prevChunkNum = null;
            let prevText = '';

            sortedChunks.forEach((chunk, idx) => {
                let text = chunk.chunk;
                let currentChunkNum = null;

                if (chunk.chunk_id && typeof chunk.chunk_id === 'string') {
                    const match = chunk.chunk_id.match(/_pages_(\d+)$/);
                    if (match) {
                        currentChunkNum = parseInt(match[1], 10);
                    }
                }

                if (idx === 0 && currentChunkNum !== 0) {
                    combinedChunk.push('..... ');
                }

                if (prevChunkNum !== null && currentChunkNum !== null) {
                    if (currentChunkNum !== prevChunkNum + 1) {
                        combinedChunk.push('...... ');
                        combinedChunk.push(<><br /></>);
                        combinedChunk.push('...... ');
                    } else {
                        combinedChunk.push(' ');
                    }
                }

                if (prevText) {
                    text = removeOverlap(prevText, text);
                }

                combinedChunk.push(text);
                prevChunkNum = currentChunkNum;
                prevText = text;
            });

            const lastText = typeof prevText === 'string' ? prevText.trim() : '';
            if (sortedChunks.length > 1 && !/[.!?]$/.test(lastText)) {
                combinedChunk.push(' ......');
            }

            const stdClauseInfo = sortedChunks[0]?.stdClauses?.[0] || {};
            const stdClauseText = stdClauseInfo.clauseLabel
                ? `${stdClauseInfo.clauseLabel} (${stdClauseInfo.clauseLabelScore})`
                : 'N/A';

            const rawHtml = decodeHtml(combinedChunk.filter(c => typeof c === 'string').join(' ')).trimStart();
            const isTable = /<table[\s\S]*?>[\s\S]*?<\/table>/i.test(rawHtml);

            clausePairs.push({
                header: {
                    key: i * 3 + 4,
                    label: 'Clause Header',
                    children: header,
                    span: 3
                },
                stdClause: {
                    key: i * 3 + 5,
                    label: (
                        <Space>
                            Std Clauses
                            <Popover placement="rightTop" content={StdClausesInfo}>
                                <InfoCircleOutlined />
                            </Popover>
                        </Space>
                    ),
                    children: stdClauseText,
                    span: 3
                },
                content: {
                    key: i * 3 + 6,
                    label: 'Clause Content',
                    children: isTable
                        ? renderHtmlTable(rawHtml)
                        : highlightKeyword(combinedChunk, keyword),
                    span: 3
                }
            });
        });

        clausePairs.sort((a, b) =>
            a.header.children.localeCompare(b.header.children, undefined, { numeric: true })
        );

        const sortedClauses = clausePairs.flatMap(pair => [pair.header, pair.stdClause, pair.content]);
        setClauses(sortedClauses);
    };

    const extractAllClauses = () => {
        const allClauseRecords = [];

        distinctData.forEach((contract, index) => {
            const contractId = contract.contractId;
            const documentName = contract.DocumentName;
            // note: contract may have allDocumentIds (added in makeDataDistinct)
            const groupedChunks = {};

            data.forEach((item) => {
                if (item.contractId === contractId && item.DocumentName === documentName) {
                    const header = item.clause_header;
                    if (!groupedChunks[header]) {
                        groupedChunks[header] = [];
                    }
                    groupedChunks[header].push(item);
                }
            });

            Object.entries(groupedChunks).forEach(([header, chunks]) => {
                const sortedChunks = chunks.sort((a, b) => {
                    const getChunkNum = (id) => {
                        const match = id?.match(/_pages_(\d+)$/);
                        return match ? parseInt(match[1], 10) : 0;
                    };
                    return getChunkNum(a.chunk_id) - getChunkNum(b.chunk_id);
                });

                let combinedChunk = [];
                let prevChunkNum = null;
                let prevText = '';

                sortedChunks.forEach((chunk, idx) => {
                    let text = chunk.chunk;
                    let currentChunkNum = null;

                    if (chunk.chunk_id && typeof chunk.chunk_id === 'string') {
                        const match = chunk.chunk_id.match(/_pages_(\d+)$/);
                        if (match) {
                            currentChunkNum = parseInt(match[1], 10);
                        }
                    }

                    if (idx === 0 && currentChunkNum !== 0) {
                        combinedChunk.push('..... ');
                    }

                    if (prevChunkNum !== null && currentChunkNum !== null) {
                        if (currentChunkNum !== prevChunkNum + 1) {
                            combinedChunk.push('...... ');
                        } else {
                            combinedChunk.push(' ');
                        }
                    }

                    if (prevText) {
                        text = removeOverlap(prevText, text);
                    }

                    combinedChunk.push(text);
                    prevChunkNum = currentChunkNum;
                    prevText = text;
                });

                const rawText = decodeHtml(combinedChunk.filter(c => typeof c === 'string').join(' ')).trimStart();

                // collect unique document ids for this clause (chunks might come from different document ids)
                const uniqueDocIds = Array.from(new Set(sortedChunks.map(s => s.id).filter(Boolean)));
                const docIdString = uniqueDocIds.join(',');

                allClauseRecords.push({
                    contractId,
                    documentId: docIdString, // comma separated if multiple
                    documentIds: uniqueDocIds, // array for more structured use
                    documentName,
                    clause_header: header,
                    chunk: rawText
                });
            });
        });

        return allClauseRecords;
    };


    const collapseData = [
        {
            key: '1',
            label: (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>Contract</span>
                    <a
                        href={`https://atos.sourcing.ariba.com/ad/viewDocument?ID=${selectedContract}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none', color: '#007bff' }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        Access Contract on Ariba
                    </a>
                </div>
            ),
            children: <Descriptions title="" bordered items={ContractInfo} />,
            span: 1
        },
        {
            key: '2',
            label: 'Scope',
            children: <Descriptions title="" bordered items={Scope} />,
            span: 1
        },
        {
            key: '3',
            label: 'Lifecycle',
            children: <Descriptions title="" bordered items={Lifecycle} />,
            span: 1
        },
        {
            key: '4',
            label: 'Stakeholders',
            children: <Descriptions title="" bordered items={Stakeholders} />,
            span: 1
        },
        {
            key: '5',
            label: 'Commercials',
            children: <Descriptions title="" bordered items={Commercials} />,
            span: 1
        },
    ];

    const RelaventClauses = [
        {
            key: '6',
            label: (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>Relevant Clauses</span>
                    <a
                        href={`https://atos.sourcing.ariba.com/ad/viewDocument?ID=${selectedContract}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none', color: '#007bff' }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        Access Contract on Ariba
                    </a>
                </div>
            ),
            children: (
                <div style={{ maxHeight: '78vh', overflowY: 'auto' }}>
                    <Descriptions title="" bordered items={clauses} />
                </div>
            ),
            span: 1,
        },
    ];

    const handleReset = () => {
        setSearchText('');
        setSelectedContracts([]);
        setSelectedClause([]);
        setSelectedSupplier([]);
        setSelectedRegion([]);
        setSelectedCommodities([]);
        setDistinctData([]);
        setData([]);
        setSelectedParentContract([]);
        setSelectedcontractType([]);
        setSelectedpaymentTerms([]);
        setSelectedsigningLegalEntity([]);
        setSelectedStdClause([]);
        setIsContract(false);
        setIsParentContract(false);
        setResultLengths([]);
        setDistDataLenght([]);
        setSelectedKeys([]);
        setQuery('');
        setPrevText('');
        setSelectAll(false);
        setSkip(0);
    };

    // Add this helper near other helpers (replace the placeholder `acquireBackendToken`)
    const acquireBackendToken = async () => {
        if (!instance) return null;
        const accounts = instance.getAllAccounts ? instance.getAllAccounts() : [];
        const account = instance.getActiveAccount ? (instance.getActiveAccount() || accounts[0]) : accounts[0];
        if (!account) return null;

        const scopesEnv = process.env.REACT_APP_API_SCOPES || process.env.REACT_APP_API_SCOPE || '';
        const scopes = scopesEnv ? scopesEnv.split(',').map(s => s.trim()) : ['openid', 'profile'];

        try {
            const tokenResp = await instance.acquireTokenSilent({ scopes, account });
            return tokenResp?.accessToken ?? null;
        } catch (silentErr) {
            try {
                const tokenResp = await instance.acquireTokenPopup({ scopes, account });
                return tokenResp?.accessToken ?? null;
            } catch (popupErr) {
                console.warn('acquireBackendToken failed', { silentErr, popupErr });
                return null;
            }
        }
    };

    return (
        <>
            {aiSummary && (
                <div style={{ margin: '12px 24px', padding: 12, background: '#fffbe6', border: '1px solid #ffe58f', borderRadius: 4 }}>
                    <strong>AI Summary (cached):</strong>
                    <div style={{ whiteSpace: 'pre-wrap', marginTop: 8 }}>
                        {Array.isArray(aiSummary) ? aiSummary.map((m, i) => (<div key={i}>{m.text ?? JSON.stringify(m)}</div>)) : (typeof aiSummary === 'string' ? aiSummary : JSON.stringify(aiSummary))}
                    </div>
                </div>
            )}
            <div className="SCAUX">
                <Layout >
                    <Header className="header" >
                        <HeaderJs />
                    </Header>
                    <Layout>
                        <Nav />
                        <Content >
                            <div className="content">
                                <div id="scrollableDiv" className="scrollable-content">
                                    <Spin spinning={loading} className="spin">
                                        <div className="searchfilter">
                                            <Breadcrumb
                                                className="page-title"
                                                items={[{
                                                    title: <span className="page-title-label">
                                                        Search Contracts</span>
                                                }]}
                                            />

                                            <Breadcrumb theme="light" className="searchBox">
                                                <label className="filter">Search :</label>
                                                <div>
                                                    <Space >
                                                        <AutoComplete
                                                            className="input"
                                                            options={autoComp ? autoComp.map(text => ({ value: text })) : []}
                                                            value={searchText}
                                                            onChange={handleInputChange}
                                                        >
                                                            <Input />
                                                        </AutoComplete>
                                                        <Popover placement="rightTop" content={content} title="How to Search">
                                                            <InfoCircleOutlined />
                                                        </Popover>
                                                    </Space>
                                                </div>
                                            </Breadcrumb>
                                            <br />
                                            <Breadcrumb theme="light" className="scope">
                                                <label className="filter">Filters :</label>
                                                <div className="filters">
                                                    <Row gutter={1}>
                                                        <Col className="gutter-row" flex="none">
                                                            <MultiSelect
                                                                options={distinctprojectId}
                                                                value={selectedContracts}
                                                                onChange={(value) => {
                                                                    setSelectedContracts(value);
                                                                    setIsContract(value.length > 0 ? true : false);
                                                                }}
                                                                placeholder="Select Contract"
                                                                disabled={isParentContract}
                                                            />
                                                        </Col>
                                                        <Col className="gutter-row" style={{ marginLeft: '2px', marginRight: '2px' }}>
                                                            <h2 style={{ marginLeft: 10 }}>or</h2>
                                                        </Col>
                                                        <Col className="gutter-row" flex="none">

                                                            <MultiSelect
                                                                options={distinctParentC}
                                                                value={selectedParentContract}
                                                                onChange={(value) => {
                                                                    setSelectedParentContract(value);
                                                                    setIsParentContract(value.length > 0 ? true : false);
                                                                }}
                                                                placeholder="Select Parent Contract"
                                                                disabled={isContract}
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row gutter={1}>
                                                        <Col className="gutter-row" flex="none">
                                                            {/* <TreeMultiSelect
                                                                options={treeData} // pass the regions array (objects) from dropdown data
                                                                // options={distinctRegion}
                                                                value={selectedRegion}
                                                                onChange={setSelectedRegion}
                                                                placeholder="Select Scope"
                                                                disabled={isContract || isParentContract}
                                                            /> */}
                                                            <StaticTreeMultiSelect  // New static tree component
                                                                options={regionTreeData} // pass the regions array (objects) from dropdown data
                                                                dataType="regions"
                                                                value={selectedRegion}  // Or use a separate state like selectedStaticRegion
                                                                onChange={setSelectedRegion}  // Or setSelectedStaticRegion
                                                                placeholder="Select Scope"
                                                                disabled={isContract || isParentContract}
                                                            />
                                                        </Col>
                                                        <Col className="gutter-row" flex="none">
                                                            <MultiSelect
                                                                options={distinctSupplier}
                                                                value={selectedSupplier}
                                                                onChange={setSelectedSupplier}
                                                                placeholder="Select Supplier"
                                                                disabled={isContract || isParentContract}
                                                            />
                                                        </Col>
                                                        <Col className="gutter-row" flex="none">
                                                            <MultiSelect
                                                                options={distinctSigningLegalEntity}
                                                                value={selectedsigningLegalEntity}
                                                                onChange={setSelectedsigningLegalEntity}
                                                                placeholder="Select Signing Legal Entity"
                                                                disabled={isContract || isParentContract}
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row gutter={1}>
                                                        <Col className="gutter-row" flex="none">
                                                            <StaticTreeMultiSelect  // New static tree component (commodities)
                                                                options={commoditiesTreeData}
                                                                dataType="commodities"
                                                                value={selectedCommodities}
                                                                onChange={setSelectedCommodities}
                                                                placeholder="Select Categories"
                                                                disabled={isContract || isParentContract}
                                                            />
                                                            {/* <MultiSelect
                                                                options={distinctCommodities}
                                                                value={selectedCommodities}
                                                                onChange={setSelectedCommodities}
                                                                placeholder="Select Categories"
                                                                disabled={isContract || isParentContract}
                                                            /> */}
                                                        </Col>
                                                        <Col className="gutter-row" flex="none">
                                                            <MultiSelect
                                                                options={distinctContractType}
                                                                value={selectedcontractType}
                                                                onChange={setSelectedcontractType}
                                                                placeholder="Select Contract Type"
                                                                disabled={isContract || isParentContract}
                                                            />
                                                        </Col>
                                                        <Col className="gutter-row" flex="none">
                                                            <MultiSelect
                                                                options={distinctStdClauses}
                                                                value={selectedStdClause}
                                                                onChange={setSelectedStdClause}
                                                                placeholder="Select Standard Clauses"
                                                                disabled={isContract || isParentContract}
                                                            />
                                                        </Col>
                                                        <Col className="gutter-row" flex="none">
                                                            <Button onClick={handleReset} style={{ marginLeft: 10 }} danger>
                                                                Clear
                                                            </Button>
                                                            <Button type="primary" onClick={() => { onSearch() }} style={{ marginLeft: 10 }}>
                                                                Search
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Breadcrumb>
                                        </div>

                                        <div style={{ marginLeft: '20px', marginTop: '10px' }}>
                                            {distinctData.length > 0 ? (
                                                <h2 style={{ display: 'flex', textIndent: '5px' }}>
                                                    Total <p style={{ color: "#f56a00", margin: '0 1px' }}>{docCount}</p> hits,
                                                    Showing: <span style={{ color: "#f56a00" }}>{resultLengths}</span> hit(s) from
                                                    <span style={{ color: "#f56a00", marginLeft: '2px' }}>{distDatalenght[distDatalenght.length - 1]}</span> documents
                                                </h2>
                                            ) : null}
                                        </div>

                                        <div style={{ marginTop: '2px', marginLeft: '20px' }}>
                                            {distinctData.length > 0 && (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', flexWrap: 'wrap' }}>
                                                    <Tooltip title={selectAll ? "Uncheck to clear selection" : "Select all visible results"}>
                                                        <Checkbox
                                                            indeterminate={isIndeterminate}
                                                            checked={selectAll}
                                                            onChange={(e) => handleSelectAllToggle(e.target.checked)}
                                                            disabled={distinctData.length === 0}
                                                        >
                                                            Select All
                                                        </Checkbox>
                                                    </Tooltip>

                                                    <Tooltip title={selectedKeys.length === 0 ? "Select one or more contracts first" : (isChecked ? "Analyzes the first 10 search results with AI. Refine the scope with search filters for targeted analysis. For analyzing over full database, use the Copilot in the left navigation." : '')}>
                                                        <span style={{ display: 'inline-block' }}>
                                                            <Button
                                                                className="CallAi"
                                                                type="primary"
                                                                onClick={handleAnalyzeClick}
                                                                disabled={selectedKeys.length <= 0}
                                                                style={{
                                                                    height: 20,
                                                                    paddingLeft: 5,
                                                                    paddingRight: 5,
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    fontSize: 12,
                                                                }}
                                                            >
                                                                Analyze Selected with AI
                                                            </Button>
                                                        </span>
                                                    </Tooltip>

                                                    <Tooltip title={selectedKeys.length === 0 ? "Select one or more contracts first" : "Export selected records to Excel"}>
                                                        <div style={{ display: 'inline-block' }}>
                                                            <ExportToExcel
                                                                data={getSelectedItemsInResultsOrder()}
                                                                clauses={extractAllClauses().filter(c => selectedKeys.includes(`${c.contractId}-${c.documentName}`))}
                                                                fileName={`Selected_Contracts`}
                                                            />
                                                        </div>
                                                    </Tooltip>
                                                </div>
                                            )}
                                        </div>

                                        <div
                                            style={{
                                                padding: distinctData.length > 0 ? '0px 24px 24px 24px' : '24px',
                                                minHeight: 380,
                                                background: colorBgContainer,
                                                borderRadius: borderRadiusLG,
                                            }}
                                        >
                                            <div
                                                id="scrollableDiv"
                                                style={{
                                                    minHeight: '40vh',
                                                    maxHeight: '40vh',
                                                    overflow: 'auto',
                                                    padding: '0 16px',
                                                    border: '1px solid rgba(140, 140, 140, 0.35)',
                                                }}
                                            >
                                                <List
                                                    className="list-content"
                                                    loading={initLoading}
                                                    loadMore={loadMore}
                                                    dataSource={distinctData}
                                                    renderItem={(item, index) => {
                                                        const key = `${item.contractId}|${item.DocumentName}`;
                                                        const clauseCount = searchResults.uniqueClauseHeaderCountsByContractIdAndDoc?.[key] || 0;
                                                        return (
                                                            <List.Item
                                                                className="actions-container"
                                                                actions={[
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <a
                                                                            href
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                handleContractInfoClick(item, index);
                                                                            }}
                                                                            style={{ minWidth: 110, textAlign: 'right', display: 'inline-block' }}
                                                                        >
                                                                            Contract Info
                                                                        </a>
                                                                        <div style={{ margin: '0 8px' }}>|</div>
                                                                        <a
                                                                            href
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                handleRelevantClausesClick(item, index);
                                                                            }}
                                                                            style={{
                                                                                minWidth: 100, // Ensures label starts at same point
                                                                                display: 'inline-flex',
                                                                                justifyContent: 'flex-start',
                                                                                alignItems: 'center'
                                                                            }}
                                                                        >
                                                                            <span style={{ minWidth: 100, display: 'inline-block' }}>Relevant Clauses :</span>
                                                                            <span style={{ minWidth: 30, textAlign: 'right', display: 'inline-block' }}>{clauseCount}</span>
                                                                        </a>
                                                                    </div>
                                                                ]}
                                                            >
                                                                <List.Item.Meta
                                                                    title={
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                                            {/* ✅ Checkbox now appears BEFORE the contractId */}

                                                                            <Checkbox
                                                                                key={keyOf(item)}
                                                                                checked={isChecked(item)}
                                                                                onChange={(e) => {
                                                                                    handleCheckBoxChange(item, index, e.target.checked);
                                                                                    e.stopPropagation();
                                                                                }}
                                                                                onClick={(e) => e.stopPropagation()}  // prevent row click side-effects
                                                                                aria-label={`Select ${item.contractId}`}
                                                                            />


                                                                            <span>{`${item.contractId} - ${item.ContractName}`}</span>
                                                                        </div>
                                                                    }
                                                                    description={
                                                                        <div>
                                                                            <p>{item.DocumentName}</p>
                                                                            <span style={{ color: 'black' }}>{item.description}</span>
                                                                        </div>
                                                                    }
                                                                />
                                                            </List.Item>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {
                                            modalType === 'Contract Info' && isModalVisible && (
                                                <ModalJs
                                                    props={collapseData}
                                                    onClose={() => setIsModalVisible(false)}
                                                />
                                            )
                                        }
                                        {
                                            modalType === 'Relevent Clauses' && isModalVisible && (
                                                <ModalJs
                                                    props={RelaventClauses}
                                                    onClose={() => setIsModalVisible(false)}
                                                />
                                            )
                                        }
                                        {/* Contract Copilot via ModalJs (NEW) */}
                                        {isChatOpen && (
                                            <ModalJs
                                                title={
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                                                            <span style={{ fontWeight: 600 }}>Contract Copilot</span>
                                                            {/* first line with the toggle link */}
                                                            <span style={{ fontSize: 12, color: '#666', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                Ask about selected{' '}
                                                                <a href onClick={(e) => { e.preventDefault(); handleToggleShowIds(); }}>
                                                                    {chatContract.selectedContracts.length} contracts
                                                                </a>
                                                                ...
                                                            </span>

                                                            {/* second line: fixed height to avoid modal reflow */}
                                                            <div
                                                                style={{
                                                                    height: 10,          // fixed; keeps modal header height constant
                                                                    transition: 'opacity 160ms ease',
                                                                    opacity: showContractIds ? 1 : 0,
                                                                    pointerEvents: showContractIds ? 'auto' : 'none',
                                                                }}
                                                            >
                                                                <code style={{ wordBreak: 'break-all', fontSize: 12, color: '#333' }}>
                                                                    {chatContract.selectedContracts.map(c => c.contractId).join(', ')}
                                                                </code>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                customTitle="Contract Copilot"
                                                customBody={
                                                    <div
                                                        style={{
                                                            height: '70vh',
                                                            minHeight: 400,
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            overflow: 'hidden',
                                                        }}
                                                    >
                                                        <div style={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
                                                            <Copilot embedded context={chatContract} containerId="webchat-embedded" />
                                                        </div>
                                                    </div>
                                                }
                                                onClose={() => setIsChatOpen(false)}
                                            />
                                        )}
                                    </Spin>
                                </div>
                            </div>
                        </Content>
                    </Layout>
                    <FooterJs />
                </Layout >
            </div >
        </>
    );
}

export default ContractSearch;